import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { map } from "rxjs/operators";
import { HierarchyNodeViewModel } from "src/core/backend/controllers";

import { SharedModule } from "#modules/shared";

import { LibraryNavigationService } from "../../services/library-navigation.service";

interface VM {
  title: string;
  downloadLink: string | null | undefined;
  coverSrc: string | undefined;
  period: Date[];
  pageCount: number | undefined;
}

@Component({
  selector: "app-book-info",
  templateUrl: "./book-info.component.html",
  styleUrls: ["./book-info.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule],
})
export class BookInfoComponent {
  private readonly navService = inject(LibraryNavigationService);

  //
  readonly vm$ = this.navService.currentDocument$.pipe(map(getVM));

  folded = false;
}

// Helper function

function buildPeriod(start: string | undefined | null, end: string | undefined | null): Date[] {
  return [start, end]
    .filter(Boolean)
    .map((d) => new Date(d!))
    .filter((d) => !isInvalidDate(d));
}

function isInvalidDate(date: Date): boolean {
  return isNaN(date.getTime());
}

function getVM(node: HierarchyNodeViewModel | undefined): VM | undefined {
  if (!node) return;
  const { periodStart, periodEnd } = node.documentObject || {};
  const pageCount =
    (node.documentObject?.pageCount ?? (node.startPage != null && node.endPage != null)) ? node.endPage - node.startPage + 1 : undefined;
  return {
    title: node.title ?? "Unbetitelt",
    coverSrc: node.resources?.cover,
    period: buildPeriod(periodStart, periodEnd),
    pageCount,
    downloadLink: node.resources?.download ?? node.resources?.display,
  };
}
